import {defineRecipe} from '@chakra-ui/react3'

const styledContentRecipe = defineRecipe({
    className: 'leap-styled-content',
    base: {
        textStyle: 'body.medium',
        '& h1': {
            textStyle: 'display.xsmall',
            marginBottom: '1em'
        },
        '& h2': {
            textStyle: 'heading.xlarge',
            marginBottom: '1em'
        },
        '& h3': {
            textStyle: 'heading.large',
            marginBottom: '1em'
        },
        '& h4': {
            textStyle: 'heading.medium',
            marginBottom: '1em'
        },
        '& p': {
            textStyle: 'body.medium',
            marginBottom: '1em'
        },
        '& div': {
            marginBottom: '1em'
        },
        '& table': {
            border: '1px solid',
            borderCollapse: 'collapse',
            padding: '1.07375rem',
            marginBottom: '1em'
        },
        '& th': {
            textStyle: 'heading.small',
            border: '1px solid',
            borderCollapse: 'collapse',
            padding: '1.07375rem',
            textAlign: 'left'
        },
        '& td': {
            textStyle: 'body.small',
            border: '1px solid',
            borderCollapse: 'collapse',
            padding: '1.07375rem'
        },
        '& ul': {
            listStyleType: 'disc',
            listStylePosition: 'outside',
            paddingLeft: 'spacing-22',
            marginBottom: '1em'
        },
        '& ol': {
            paddingLeft: 'spacing-22',
            marginBottom: '1em'
        },
        '& .sk-regular-xl': {
            textStyle: 'heading.xlarge'
        },
        '& .sk-regular-4_5xl': {
            textStyle: 'display.small'
        },
        '& .sk-regular-4xl': {
            textStyle: 'display.xsmall'
        },
        '& .sk-regular-2xl': {
            textStyle: 'heading.xlarge'
        },
        '& .sk-semibold-medium': {
            textStyle: 'heading.medium'
        },
        '& .sk-regular-medium': {
            textStyle: 'heading.medium'
        },
        '& .sk-light-medium': {
            textStyle: 'body.medium'
        },
        '& .sk-regular-small': {
            textStyle: 'body.small'
        },
        '& .sk-semibold-small': {
            textStyle: 'heading.small'
        },
        '& .sk-regular-badges': {
            textStyle: 'labels.medium'
        },
        '& .sk-usp-list': {
            textStyle: 'body.small',
            listStyleType: 'none',
            paddingLeft: 'spacing-6'
        },
        '& .sk-usp-list > li::before': {
            content: '"✓"',
            marginLeft: '-spacing-5',
            marginRight: 'spacing-2'
        },
        '& .sk-usp-list > li:not(:last-of-type)': {
            marginBottom: 'spacing-4'
        }
    }
})

export default styledContentRecipe
